import { redirect, useSearchParams } from "react-router-dom";
import { LottieLoader } from "../components/loader";
import { useCallback, useEffect } from "react";
import { PolymerAxios } from "../utils/axios";
import config from "../config";
import { Helpers } from "../utils/helper";
import { useAppSelector } from "../redux/hook";

const Logout = () => {
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);

  const clearData = useCallback(() => {
    Helpers.clearSingpassAuthPersistData();
    Helpers.clearAuthPersistData();
    Helpers.clearPersistData();
  }, [])

  useEffect(() => {
    if(singpassToken){
      PolymerAxios('',singpassToken).get(`${config.singpassLogoutUrl}`).then(res=>{
        clearData();
        window.location.href = res.data;
      }).catch((e:any)=>{
        console.error("LOGOUT ERROR- ", e);
        clearData();
        window.location.href = "/transfer";
      })
    }else{
      clearData();
      window.location.href = "/transfer";
    }
  }, [singpassToken]);

  return (
    <div>
      <LottieLoader />
    </div>
  );
};

export default Logout;
